<!--
 * @Description: 
 * @Author: houcw
 * @Date: 2023-06-11 11:16:43
 * @LastEditTime: 2023-10-27 16:03:24
 * @LastEditors: houcw
 * @Reference: 
-->
<template>
  <div class="home">
    <router-view></router-view>
  </div>
</template>

<script>
import Nav from "../components/Nav.vue";
export default {
  name: "App",
  components: {
    Nav,
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: rgb(39, 42, 55);
  // border-radius: 15px;
  // position: absolute;
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
}
</style>